import {GET, POST} from "@/services/gateway";

const getReport = (data) => {
  const {module, eventType, status, ...rest} = data;

  const transformedData = {
    ...rest,
    modules: module,
    eventTypes: eventType,
    statuses: status,
  };

  return POST('report/summary', transformedData);
}

const getOtherEventsReport = (data) => {
  const {module, eventType, status, ...rest} = data;

  const transformedData = {
    ...rest,
    modules: module,
    eventTypes: eventType,
    statuses: status,
  };

  return POST('report/summary/other', transformedData);
}

const listEventLogs = (data) => {
  const {module, eventType, status, ...rest} = data;

  const transformedData = {
    ...rest,
    modules: module,
    eventTypes: eventType,
    statuses: status,
  };

  return POST('report/events', transformedData);
};

const exportEventLogs = (data) => {
  const currentDate = new Date();
  const {module, eventType, status, ...rest} = data;

  const transformedData = {
    ...rest,
    modules: module,
    eventTypes: eventType,
    statuses: status,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  };

  return POST('report/export', transformedData);
}

const listWebActivityLogs = (data) => {
  return POST('report/user-activity-log', data);
}

const exportWebActivityLogs = (data) => {
  const currentDate = new Date();

  return POST('report/export-user-activity-log', {
    ...data,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  });
}

const getJobDetails = (id) => {
  return GET(`report/events/${id}`,)
}

export {
  getReport,
  getOtherEventsReport,
  listEventLogs,
  exportEventLogs,
  getJobDetails,
  listWebActivityLogs,
  exportWebActivityLogs,
}
